import { Box, Button, List, ListItem, Slider } from "@mui/material";
import React from "react";
// import styles from "@/styles/components/videofeaturedbuttons.module.scss"
import styles from "../../../styles/components/videofeaturedbuttons.module.scss";
import styles1 from "../../../styles/components/copywriterPendingTitlingPage.module.scss";
// import Image from 'next/image'
// import assest from '@/json/assest'
import VideoNextIcon from "../../../ui/Icons/VideoNextIcon";
import VideoVolumeIcon from "../../../ui/Icons/VideoVolumeIcon";
import VideoSettingsIcon from "../../../ui/Icons/VideoSettingsIcon";
import VideoScreenIcon from "../../../ui/Icons/VideoScreenIcon";
import assest from "../../../json/assest";
import { formatTime } from "../../../lib/functions/utils.lib";

const VideoFeaturedButtonsCustom = ({ videoControl }) => {
  //   console.warn("videoControl", videoControl);

  const {
    videoState,
    playPauseHandler,
    fastFowardHandler,
    muteHandler,
    toggleFullscreen,
    handleChangeSlider,
  } = videoControl;
  // console.warn("videoState", videoState.loaded);
  return (
    <Box className={`${styles.videoEditor} ${styles1.videoEditor}`}>
      <List>
        <ListItem>
          <Button onClick={playPauseHandler} className={styles.playPauseBtn}>
            <img
              src={
                videoState?.playing
                  ? assest.pauseButtonIcon
                  : assest.playButtonIcon
              }
              width={35}
              height={35}
              alt=""
            />
          </Button>
          {/* <Button className={styles.playPauseBtn}><Image src={assest.pauseButtonIcon} width={35} height={35} alt='' /></Button> */}
        </ListItem>
        <ListItem>
          <Box className={styles.videoRangeWrap}>
            <p>{formatTime(videoState.playedSeconds)}</p>
            <Box width={298} className={styles.videoRange}>
              <Slider
                // defaultValue={0}
                value={videoState.played * 100}
                aria-label="Default"
                valueLabelDisplay="off"
                onChange={(e) => {
                  //   console.warn("e", e.target.value);
                  handleChangeSlider(e.target.value);
                }}
              />
            </Box>
            <p className={styles.endtime}>
              {formatTime(videoState.loadedSeconds / videoState.loaded)}
            </p>
          </Box>
        </ListItem>
        <ListItem className={styles.vdoNxt}>
          <Button onClick={fastFowardHandler}>
            <VideoNextIcon />
          </Button>
        </ListItem>
        <ListItem className={styles.btnPos}>
          <Button onClick={muteHandler}>
            <VideoVolumeIcon />
          </Button>
        </ListItem>
        <ListItem className={styles.btnPos}>
          <Button>
            <VideoSettingsIcon />
          </Button>
        </ListItem>
        <ListItem className={styles.btnPos}>
          <Button onClick={toggleFullscreen}>
            <VideoScreenIcon />
          </Button>
        </ListItem>
      </List>
    </Box>
  );
};

export default VideoFeaturedButtonsCustom;
